<section class="section breadcrumbs-custom">
    <div class="breadcrumbs-custom-main bg-image bg-employer-profile">
        <div class="container">
            <h3 id="textInImage" class="breadcrumbs-custom-title">Προφίλ Εταιρείας</h3>
        </div>
    </div>
    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul class="breadcrumbs-custom-path">
                <li><a style="color:#1087eb;" routerLink="/">Αρχική</a></li>
                <li class="active"> Προφίλ Εταιρείας</li>
            </ul>
        </div>
    </div>
</section>

<section class="section section-md">
    <div class="container">
        <app-alert-message *ngIf="companyData.activationStatus==='pending' && loggedInCompanyProfile" [alertOption]="4"></app-alert-message>
        <app-alert-message *ngIf="companyData.activationStatus==='disapproved' && loggedInCompanyProfile" [alertOption]="5"></app-alert-message>
        <div class="row">
            <div class="col-lg-8 col-md-12 col-sm-12 col-12">
                <div class="layout-details">
                    <div class="row">

                        <!-- company's logo -->
                        <div class="col-lg-3 col-md-2 col-sm-3 col-12 col-context">
                            <img *ngIf="companyData.logo" class="img-thumbnail company-logo" src="{{companyData.logo}}" alt="" />
                            <img *ngIf="!companyData.logo" class="img-thumbnail company-logo" src="assets/images/defaultcompanylogo.jpg" alt="" />
                        </div>

                        <!-- info -->
                        <div style="padding-top: 10px;" class="col-lg-6 col-md-6 col-sm-5 col-12 vertical-line">
                            <h5 class="context-break">{{companyData.name}}</h5>
                            <p class="p-margin" *ngIf="companyData && companyData.industryName">{{companyData.industryName}}</p>
                            <p *ngIf="companyData && companyData.locationName" class="p-margin context-break object-inline object-inline_sm"><span class="icon icon-1 mdi mdi-map-marker text-primary"></span><span>
                                {{companyData.locationName}}</span></p>
                            <p *ngIf="jobList" class="p-margin object-inline object-inline_sm"><span class="icon icon-1 mdi mdi-file-document text-primary"></span><span>
                                    {{jobList.totalElements}} Δημοσιευμένες Θέσεις</span></p>
                        </div>

                        <!-- social icons -->
                        <div class="col-lg-3 col-md-4 col-sm-4 col-12 col-context">
                            <ul style="text-align: center" class="list-inline list-inline-xs">
                                <li *ngIf="companyData.email">
                                    <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fas fa-envelope" style="background: #ca5217; font-size: 16px;" href="mailto:{{companyData.email}}"></a>
                                </li>
                                <li *ngIf="companyData.facebookUrl">
                                    <a style="background: #5776b7; font-size: 16px;" class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-facebook" href="{{companyData.facebookUrl}}"></a>
                                </li>
                                <li *ngIf="companyData.website">
                                    <a style="background: #ca5217; font-size: 16px;" class="icon icon-xxs icon-filled icon-filled-brand icon-circle mdi mdi-web" href="{{companyData.website}}"></a>
                                </li>
                                <li *ngIf="companyData.linkedInUrl">
                                    <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-linkedin" style="color:white; background: #5776b7; font-size: 16px;" href="{{companyData.linkedInUrl}}"></a>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

                <h4 *ngIf="companyData.description || companyData.motto || companyData.numberEmployees || companyData.yearFounded" class="heading-decorated_1">Σχετικά με την Εταιρεία</h4>

                <p id="descriptionParagraph" class="text-style-1" [innerHtml]="companyData.description | safe"></p>
                <br/>
                <span *ngIf="companyData.motto"><span style="color: black;">Μotto Εταιρείας:</span> {{companyData.motto}}</span>
                <br/>
                <span *ngIf="companyData.numberEmployees"><span style="color:black;"> Αριθμός εργαζομένων:</span> {{companyData.numberEmployees}}</span>
                <br/>
                <!-- <span *ngIf="companyData.yearFounded"><span style="color:black;">Έτος Ίδρυσης εταιρείας:</span> {{companyData.yearFounded}}</span>
                <br/> -->

                <button *ngIf="jobList && jobList.totalElements>0 && companyData.id===this.authService.getCompanyId()" type="button" class="btn btn-link heading-decorated_1">
                    <a [routerLink] = "['/employers/job-listing/all']" class="published-title">Δημοσιευμένες Θέσεις Εργασίας</a>
                </button>

                <h4 *ngIf="companyData.id!=this.authService.getCompanyId()" class="heading-decorated_1 published-title">Δημοσιευμένες Θέσεις Εργασίας
                </h4>
                <br />
                <br />

                <!-- published Jobs table -->
                <div class="col-lg-12">
                    <form *ngIf="metadata$ | async as metadata">
                        <table class="table table-hover">
                            <tr class="tr-published-job-listing" ngDefaultControl [attr.data-item-value]="content.title" *ngFor="let content of items">
                                <td class="td-published-job-listing">
                                    <article>
                                        <div>
                                            <h5 class="company-minimal-title userSelect">
                                                <a [routerLink]="['/job-details',content.uuid]" placement="top-left" ngbTooltip={{content.title}}>{{content.title}}</a>
                                            </h5>
                                            <p *ngIf="content.locationName"><span style="color:grey;" class="icon icon-1 text-primary mdi mdi-map-marker"></span>{{content.locationName}} </p>
                                            <p *ngIf="!content.locationName"> - </p>
                                        </div>
                                    </article>
                                </td>

                                <!-- style for employment type label -->

                                <td *ngIf="content.employmentTypesName=='Πρακτική Άσκηση'" class="td-context-align">
                                    <span class="badge badge-context">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Συμβασιούχος'" class="td-context-align">
                                    <span class="badge badge-secondary badge-context">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Ελεύθερος επαγγελματίας'" class="td-context-align">
                                    <span class="badge badge-tertiary badge-context">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Ασκούμενος'" class="td-context-align">
                                    <span class="badge badge-tertiary badge-context">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Μερική Απασχόληση'" class="td-context-align">
                                    <span class="badge badge-blue-11">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Πλήρης Απασχόληση'" class="td-context-align">
                                    <span class="badge badge-yellow-12 badge-context">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Εποχική/Προσωρινή απασχόληση'" class="td-context-align">
                                    <span class="badge badge-season badge-context">{{content.employmentTypesName}}</span></td>

                                <td *ngIf="content.employmentTypesName=='Μη διαθέσιμο'" class="td-context-align">
                                    <span class="badge badge-undefined badge-context"></span></td>
                            </tr>
                        </table>
                    </form>

                    <!-- pagination -->
                    <app-pagination-bs [items]="jobList" [pageSize]="pageSize" (changePage)="onChangePage($event)"></app-pagination-bs>

                </div>
                <br />
            </div>

            <div *ngIf="companyData.id===this.authService.getCompanyId()" class="col-lg-4 col-md-12 col-sm-12 col-12 form-corporate">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-12">
                        <form style="margin-top: 10%; margin-bottom: 10%;" class="rd-mailform form-corporate form-spacing-small form-corporate_sm" data-form-output="form-output-global" data-form-type="contact" method="post" action="bat/rd-mailform.php">
                            <div class="row">
                                <a [routerLink]="['/employers/complete-profile']" class="anchorOnbuttons"><button class="button button-block button-primary button-context">
                                   Επεξεργασια Προφιλ</button>
                                </a>
                            </div>
                            <br />
                            <div *ngIf="companyData && companyData.isValid" class="row">
                                <a class="anchorOnbuttons" [routerLink]="['/employers/post-a-job']">
                                    <button class="button button-block button-primary button-context" type="submit">Αναρτηση νεας θεσης
                                        Εργασιας</button>
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div *ngIf="companyData.id!==this.authService.getCompanyId()" class="col-lg-4 col-md-12 col-sm-12 col-12 form-corporate">
            </div>

        </div>
    </div>
</section>